import { render } from "./SettingsPinCodeTicket.vue?vue&type=template&id=b74a9ee2"
import script from "./SettingsPinCodeTicket.vue?vue&type=script&lang=js"
export * from "./SettingsPinCodeTicket.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__